import { ApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { PointsBalanceStatementData } from './pointsBalanceStatement.types';
const getPointsBalanceStatement = (client: AxiosInstance) => async () => {
  return (await client.get<ApiResponse<PointsBalanceStatementData[]>>('/pointsBalanceStatement')).data;
};

export const pointsBalanceStatementQueries = {
  all: () => ['pointsBalanceStatement'],

  list: () =>
    queryFactoryOptions<ApiResponse<PointsBalanceStatementData[]>>({
      queryKey: [...pointsBalanceStatementQueries.all(), 'list'],
      queryFn: (client) => getPointsBalanceStatement(client),
    }),
};
